<template>
  <v-container
    style="
      height: 100vh;
      background-color: #f4f5f8;
      max-width: 100%;
      overflow: hidden;
    "
    class="pa-0"
  >
    <v-alert text type="info" style="position: fixed; width: 100%">
      本Demo仅用于演示互动白板产品功能，源码对外开放，可供您接入时参考，但是Demo本身未经过严格测试，若您计划将Demo代码用于生产环境，请确保发布前自行进行充分测试，避免发生潜在问题可能给您造成损失
    </v-alert>
    <v-row style="height: 100%; overflow: hidden" align="center">
      <v-col align-self="center">
        <v-card
          class="mx-auto pa-4"
          max-width="480"
          style="box-shadow: 3px 3px 30px rgb(0 0 0 / 8%)"
        >
          <v-card-text>
            <div class="mb-4">
              <p>欢迎使用</p>
              <h2 class="text--primary">互动白板-体验课堂</h2>
            </div>
            <v-form ref="form" v-model="valid">
              <v-text-field
                v-model="userId"
                :rules="[(v) => !!v || '用户ID必填']"
                label="用户ID"
                required
              ></v-text-field>

              <v-text-field
                v-model="classId"
                :rules="[
                  (v) => !!v || '房间号必填',
                  (v) => /^\d+$/.test(String(v)) || '房间号为整数',
                ]"
                label="房间号（必填）"
                required
              ></v-text-field>

              <v-text-field
                v-model="dowmGradeTimes"
                label="H5降级渲染参数（选填）"
                :rules="[(v) => /^\d+$/.test(String(v)) || '参数为整数']"
              ></v-text-field>

              <v-text-field
                v-model="imGroupId"
                label="IM群组ID（选填）"
              ></v-text-field>

              <v-text-field
                v-model="nickname"
                label="昵称（选填）"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="#008CBA"
              class="mx-auto"
              style="width: 120px;color:#fff;"
              rounded
              @click="showScrollbarSettingPanel"
            >
              滚动条设置
            </v-btn>
            <v-btn
              color="secondary"
              class="mx-auto"
              style="width: 120px"
              rounded
              @click="showSelectBoxSettingPanel"
            >
              课前设置
            </v-btn>
            <v-btn
              :disabled="!valid"
              color="primary"
              class="mx-auto"
              style="width: 120px"
              rounded
              @click="joinHandler"
            >
              加入课堂
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <select-box-setting-dialog
      ref="settingDialogRef"
    ></select-box-setting-dialog>
    <scrollbar-setting-dialog
      ref="scrollbarDialogRef"
    ></scrollbar-setting-dialog>
  </v-container>
</template>

<script>
import Util from '../util/Util';
import SelectBoxSettingDialog from './SelectBoxSettingDialog.vue';
import ScrollbarSettingDialog from './ScrollbarSettingDialog.vue';

export default {
  name: 'Login',

  components: {
    SelectBoxSettingDialog,
    ScrollbarSettingDialog,
  },

  data() {
    return {
      tim: null,
      valid: false,
      sdkAppId: 1400127140,
      userId: '',
      classId: null,
      imGroupId: null,
      nickname: '',
      dowmGradeTimes: 0,
    };
  },

  mounted() {
    this.userId = `tiw_web_${Math.ceil(Math.random() * 1000)}`;
  },

  methods: {
    async joinHandler() {
      if (this.valid) {
        // 1. 获取签名信息
        const [error, res] = await Util.awaitWrap(this.getUserSig());
        if (error) {
          this.$toasted.error('获取签名出错, 请重试');
          return;
        }
        this.userSig = res.userSig;
        this.joinClassroom();
      } else {
        this.$toasted.error('请输入合法用户ID和房间号');
      }
    },

    async joinClassroom() {
      this.$store.commit('classInfo', {
        sdkAppId: Number(this.sdkAppId),
        userId: String(this.userId),
        classId: String(this.classId),
        imGroupId: this.imGroupId,
        userSig: String(this.userSig),
        nickname: String(this.nickname),
        dowmGradeTimes: Number(this.dowmGradeTimes),
      });
      this.$router.push('/');
    },

    async getUserSig() {
      const instance = window.axios.create({
        baseURL:
          'https://tiw-3gflb4tn0d7f550f-1259648581.ap-shanghai.app.tcloudbase.com/',
        timeout: 5000,
      });
      const res = await instance.get(
        `/get_tiw_token?userId=${this.userId}&timestamp=${Date.now()}`
      );
      return res.data;
    },

    showSelectBoxSettingPanel() {
      this.$refs['settingDialogRef'].show();
    },

    showScrollbarSettingPanel() {
      this.$refs['scrollbarDialogRef'].show();
    },
  },
};
</script>
